import { Link, NavLink } from 'react-router-dom';

const Header = () => {
    const navbar = [
        { id: 'training', description: 'Formazione' },
        { id: 'services', description: 'Servizi' },
        { id: 'editorials', description: 'Editoriali' },
        { id: 'showcase', description: 'Showcase' },
        { id: 'team', description: 'Team' },
        { id: 'contact', description: 'Contatti' },
    ];

    return (
        <header id='header' className='header fixed-top'>
            <div className='container-fluid container-xl position-relative'>
                <nav className='navbar navbar-expand-lg'>
                    <div className='container-fluid'>
                        <Link to='/' className='logo navbar-brand'>
                            <img src={'/img/logo.webp'} alt='Logo Glami Inside Fashion' />
                        </Link>
                        <button
                            className='navbar-toggler'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#navbarToggler'
                            aria-controls='navbarToggler'
                            aria-expanded='false'
                            aria-label='Toggle navigation'
                        >
                            <i className='bi bi-list fs-2'></i>
                        </button>

                        <div className='collapse navbar-collapse mt-3 mt-lg-0' id='navbarToggler'>
                            <ul className='navbar-nav ms-auto mb-2 mb-lg-0'>
                                {navbar.map(item => {
                                    return (
                                        <li key={item.id} className='nav-item'>
                                            <NavLink className='nav-link me-4' to={`/${item.id}`}>
                                                {item.description}
                                            </NavLink>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
};
export default Header;
